import Area from '@/components/Area';
import { shaderMaterial, useTexture } from '@react-three/drei';
import { Canvas, extend, ReactThreeFiber, useFrame } from '@react-three/fiber';
import * as React from 'react';
import img1 from './Img1.jpg';
import img2 from './Img2.jpg';
import displacement10 from './displacement/10.jpg';
import displacement11 from './displacement/11.jpg';
import displacement12 from './displacement/12.jpg';
import displacement13 from './displacement/13.jpg';
import * as THREE from 'three';
import vert from './camera.vert';
import frag from './image-blending.frag';

type TextureChangeShaderProps = {
  uTexture1?: THREE.Texture;
  uTexture2?: THREE.Texture;
  blendRatio?: number;
};

const TextureChangeShader = shaderMaterial(
  {
    uTexture1: null,
    uTexture2: null,
    blendRatio: 0,
  },
  vert,
  frag
);

extend({ TextureChangeShader });

declare global {
  namespace JSX {
    interface IntrinsicElements {
      textureChangeShader: ReactThreeFiber.Node<
        typeof TextureChangeShader & JSX.IntrinsicElements['shaderMaterial'],
        TextureChangeShaderProps
      > &
        TextureChangeShaderProps;
    }
  }
}

function FadingImage() {
  const [textureImg1, textureImg2] = useTexture([
    img1.src,
    img2.src,
    displacement10.src,
    displacement11.src,
    displacement12.src,
    displacement13.src,
  ]);
  const [hovered, setHovered] = React.useState(false);
  const ref = React.useRef<JSX.IntrinsicElements['textureChangeShader']>(null);
  useFrame(() => {
    const shader = ref.current;
    if (!shader) return;
    shader.blendRatio = THREE.MathUtils.lerp(shader.blendRatio || 0, hovered ? 1 : 0, 0.035);
  });
  return (
    <mesh onPointerEnter={() => setHovered(true)} onPointerLeave={() => setHovered(false)}>
      <planeGeometry />
      <textureChangeShader ref={ref as any} uTexture1={textureImg1} uTexture2={textureImg2} />
    </mesh>
  );
}

export type Props = {};

function App01(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas camera={{ position: [0, 0, 2], fov: 50 }}>
          <ambientLight />
          <FadingImage />
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App01);
